import React, {useContext} from "react";
import {observer} from "mobx-react-lite";
import DesignerView from "../../../components/qr/designer/DesignerView";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input, InputGroup, InputGroupAddon,
  Label,
  Row
} from "reactstrap";
import {StateContext} from "../../../App";
import { useRouterStore} from "mobx-state-router";
import {FormattedMessage} from "react-intl";
import QrPreviewImageView from "../../../components/qr/qrpreview/qrPreviewImage/QrPreviewImageView";
import QrConfigSelect from "../../elements/qrconfig/QrConfigSelect";
import "./DesignerModal.css"
import DisableWrapper from "../../../utils/disableWrapper";
import { getSnapshot } from "mobx-state-tree";

const DesignerModal = observer(({store, currentState}) => {
  const stateContext = useContext(StateContext);
  // Set up upload listeners on every render to ensure MobX tracking
  store?.setupMediaFileUploadListeners();
  store?.resetUploadCancelFlags();
  const createCodeViewState = stateContext.rootUiStore.createCodeViewState
  const editCodeState = stateContext.rootUiStore.editCodeState
  const qrPreviewStore = stateContext.rootUiStore.qrPreviewStore
  const {designerViewStore} = store
  //TODO: PATTERN VIOLATION - setGenerateImageListener called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  designerViewStore?.setGenerateImageListener((data) => qrPreviewStore?.setQRImageFormData(data, true))
  const qrConfigSelectStore = stateContext.rootUiStore.qrConfigSelectStore
  // const store = stateContext.rootUiStore.previewCodeAndEditDesign
  const qrConfigStore = stateContext.domainStore.qrConfigStore
  //hydrate designerViewStore with qrConfigSelectStore
  //TODO: PATTERN VIOLATION - setOnSelectChanges called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  qrPreviewStore.setOnSelectChanges()
  //TODO: PATTERN VIOLATION - setHydrateModal called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  qrConfigSelectStore?.setHydrateModal(designerViewStore?.hydrateEditComponent)

  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;
  //const selectedGroupUUid = !params.id? createCodeViewState.groupSelectStore?.selectedGroup?.uuid : editCodeState?.groupSelectStore?.selectedGroup?.uuid
  const selectedGroupUUid = stateContext.rootUiStore.groupSelectStore?.selectedGroup?.uuid
  //TODO: PATTERN VIOLATION - setSelectedGroup called on every render
  // See correct pattern: setOnSelectChanges() in src/routes/codes/index.js onEnter
  qrConfigSelectStore.setSelectedGroup(selectedGroupUUid)
  const isDisabled = store.isView;
  //qrConfigSelectStore.configStore.setFilterOn(selectedGroupUUid)
  return (
    <Card>
      <DisableWrapper isDisabled={isDisabled}>
        <CardBody>
          <Row>
            <Col sm={2}>
              <FormGroup check>
                <Input name="utm"
                       type="radio"
                       id="customOpen"
                       value={store.customOpen}
                       checked={store.customOpen}
                       onClick={() => {
                         store.setCustomOpen()
                       }}
                />
                 <Label check>
                  <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.new.defaultMessage"/>
                </Label>
              </FormGroup>
            </Col>
            {store.customOpen &&
            <>
              <Col sm={5}>
                <InputGroup className="mb-3">
                  <InputGroupAddon addonType="prepend"
                    // label={intl.formatMessage({id: 'createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage'})}
                  >
                    Autofill Form
                    {/*<FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.autofillForm.defaultMessage"/>*/}
                  </InputGroupAddon>
                  <QrConfigSelect store={qrConfigSelectStore} disabled={isDisabled}/>
                </InputGroup>
              </Col>
            </>
            }
             <Col sm={2}>
              <FormGroup check>
                <Input name="design"
                       type="radio"
                       id="noDesign"
                       value={store.noDesignOpen}
                       checked={store.noDesignOpen}
                       onClick={() => {
                         store.setNoneOpen()
                       }}
                />
                <Label check>
                  None
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm={8}>

          {store.customOpen &&
                  <DesignerView
                      store={designerViewStore}
                      isNotCodeModal = {false}
                  />
          }
              {!store.customOpen &&
                <hr/>
              }
                  <Row className="p-1">
                    <Col sm={2}>
                      <Button id="cancel-btn" color="secondary"
                              onClick={async () => {
                                // editCodeState && editCodeState.modalStore.toggle()
                                // createCodeViewState && createCodeViewState.modalStore.toggle()
                                store.discardChanges(currentState)
                                currentState.modalStore.toggle()
                              }}
                      >Cancel</Button>
                    </Col>
                    <Col  id="apply-btn" sm={10} className="text-right">
                      <Button outline color="primary"
                        disabled={store?.isUploadingMedia}
                              onClick={async () => {
                                  //const uuid =  store.isEditCodePage? editCodeState?.imageUuid:createCodeViewState?.imageUuid
                                  const uuid = currentState?.imageUuid
                                  const res = uuid ? await store?.updateDesign(uuid, currentState) : await store?.applyDesign(currentState)

                                  if (store.noDesignOpen) {
                                    qrPreviewStore.setPreviewImageNull()
                                    // use case only for batch edit, mark the designer modal is blue
                                    if(currentState.batchType && currentState.batchType === "Edit") {
                                      store.setRemovedDesignerModal(true)
                                    }
                                  } else {
                                    qrPreviewStore?.setQRImageFormData(designerViewStore.extendConfig, true)
                                    // qrConfigSelectStore.setSelectedConfig(qrConfigStore.defaultConfiguration[0]);
                                  }
                                  currentState?.modalStore.toggle()
                               }
                              }
                      > Apply </Button>
                    </Col>
                  </Row>
            </Col>
            <Col sm={2} >
              <div  className="fix-preview-image">
                {store.customOpen &&
                  <>              <QrPreviewImageView
                    store={qrPreviewStore}
                  />
                    <Row>
                      <Col className="text-center">
                        <Button id="preview-btn" className="align-content-end" onClick={designerViewStore.handleUpdateImage}>
                          <FormattedMessage id="qrDesign.create.previewImage.defaultMessage"/>
                        </Button>
                      </Col>
                    </Row>
                  </>
                }
              </div>
            </Col>
          </Row>
        </CardBody>
      </DisableWrapper>
    </Card>

  )

})


export default DesignerModal;
